import { FormattedMessage } from "react-intl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  Assets,
  DashboardIconBlack,
  Filee,
  NavBill,
  NavUser,
  Toget,
} from "utils/asset";

const Icon = ({ src, alt }) => <LazyLoadImage src={src} alt={alt} width="16" />;

// ==============================|| MENU ITEMS - PAGES ||============================== //

const masterDataPages = {
  id: "master-group-pages",
  title: <FormattedMessage id="master data" />,
  type: "group",
  children: [
    {
      id: "users",
      title: <FormattedMessage id="users" />,
      type: "item",
      url: "/user",
      icon: () => <Icon src={NavUser} alt="invoice icon" />,
      subject: "User",
    },
    {
      id: "woking-unit",
      title: <FormattedMessage id="working unit" />,
      type: "item",
      url: "/work-unit",
      icon: () => <Icon src={Toget} alt="invoice icon" />,
      subject: "Working Unit",
    },

    // {
    //   id: "companies",
    //   title: <FormattedMessage id="Companies" />,
    //   type: "item",
    //   url: "/companny",
    //   icon: () => <Icon src={NavUser} alt="invoice icon" />,
    //   subject: "Company",
    // },
    {
      id: "service",
      title: <FormattedMessage id="service" />,
      type: "item",
      url: "/services",
      // icon: NavBill,
      icon: () => <Icon src={NavBill} alt="service icon" />,
      subject: "Service",
    },
    {
      id: "cost-components",
      title: "Komponen Biaya",
      type: "item",
      url: "/cost-components",
      icon: () => <Icon src={NavBill} alt="cost icon" />,
      subject: "CostComponent",
    },
    // {
    //   id: "base-price",
    //   title: <FormattedMessage id="base price" />,
    //   type: "item",
    //   url: "/base-price",
    //   // icon: NavBill,
    //   icon: () => <DesignServices sx={{ fontSize: 18 }} />,
    //   subject: "Base Price",
    // },
  ],
};

export default masterDataPages;
